<template>
  <bvue-ui-view class="flex flex-col">
    <h2>Diagramar el contorno del Área</h2>
    <div class="flex-1 w-full" id="map" />
    <div class="flex justify-end mt-3 mr-3">
      <button class="btn btn-red" @click="$bvueUi.modal.close()">Cancelar</button>
      <button :class="['btn', 'btn-primary', 'ml-2', loading]" @click="store">Guardar contorno</button>
    </div>
  </bvue-ui-view >
</template>

<script>
import firebase from '@/firebase'
export default {
  name: 'PathEditor',
  props: {
    modalData: Object
  },
  data () {
    return {
      loading: [],
      options: {
        zoom:7,
        center: {
          lat: -1.0,
          lng: -76.0
        },
        scaleControl: true,
        mapTypeControl: false,
        zoomControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeId: 'hybrid',
      },
      map: null,
      polygon: null
    }
  },
  methods: {
    async store() {
      this.loading = ['loading', 'disabled']
      const mvcArray = await this.polygon.getPath()
      const path = this.getPath(mvcArray)
      var region = this.modalData.region
      region.path = path
      console.log('new path: ', path)
      await firebase.firestore.collection('reserves').doc(this.modalData.id).update({region})
      this.$bvueUi.modal.close()
      this.loading = []
    },
    getPath(mvcArray) {
      let path = [];
      for (let i=0; i<mvcArray.length; i++) {
        let point = mvcArray.getAt(i);
        path.push({lat: point.lat(), lng: point.lng()});
      }
      return path;
    }
  },
  mounted() {
    this.map = new google.maps.Map(document.getElementById("map"), this.options);

    this.polygon = new google.maps.Polygon({
      ...this.modalData.region,
      editable: true,
      draggable: true
    });

    this.polygon.setMap(this.map)

    // Add tree on click
    // this.polygon.addListener('click', (e) => {
    //   const lat = e.latLng.lat()
    //   const lng = e.latLng.lng()
    //   console.log('polygon clicked: ', lat, lng)
    //   const item = {
    //     position:{
    //       lat:lat, 
    //       lng:lng, 
    //       alt:0, 
    //       accuracy: 0
    //     },
    //     specie: 'wXGD4YDY6NXCB2UzNkDc',
    //     csvLatLng: lat+''+lng,
    //     date: new Date().getTime()
    //   }
    //   firebase.firestore.collection('reserves').doc(this.modalData.id).collection('trees').add(item)
    // });

    var bounds = new google.maps.LatLngBounds();
    this.modalData.region.path.forEach(item => {
      bounds.extend(item);
    });

    const trees = this.modalData.trees ? this.modalData.trees : []
    console.log('trees: ', trees)
    for (const key in trees) {
      const tree = trees[key];
      const geo = new google.maps.LatLng(tree.position.lat, tree.position.lng);
      const marker = new google.maps.Marker({
        map: this.map,
        position: geo
      });
      bounds.extend(geo)
    };

    this.map.fitBounds(bounds);
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admin/PathEditor.vue